module.exports = __webpack_public_path__ + "desplegar.49fc4a8a53b340c1121f.svg";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/img/iconos_v2/desplegar.svg
// module id = ../../../../../src/assets/img/iconos_v2/desplegar.svg
// module chunks = styles